module.exports = __webpack_public_path__ + "assets/img/graph_marker_small.svg";